import { Fragment } from 'react/jsx-runtime';

import type { Brand } from '~/modules/branding/types';

export const defaultBrandContext: Brand = {
  name: null,
  product: '',
  title: '',
  titleTemplate: '',
  meta: <Fragment />,
  oktaConfig: {},
  pulseInsightsToken: '',
};
